import React, { PureComponent } from 'react';

import styled, { css } from 'styled-components';

import CenteredContainer from './CenteredContainer';
import FixedContainer from './FixedContainer';

// @tolicodes: not sure why z-index 4
const Footer = styled(FixedContainer)`
  bottom: 0;

  z-index: 4 !important;

  ${({ theme }) => css`
    box-shadow: ${theme.colors.materialOrder.qa.footerShadow};
  `};

  ${CenteredContainer} {
    ${({ theme }) => css`
      padding-top: ${theme.utils.pxToRem(10)}rem;
      padding-bottom: ${theme.utils.pxToRem(10)}rem;
    `}
    display: flex;
    justify-content: flex-end;
  }
`;

export default class FixedFooter extends PureComponent {
  render() {
    const { innerRef, children } = this.props;

    return (
      <Footer innerRef={innerRef}>
        <CenteredContainer>{this.props.children}</CenteredContainer>
      </Footer>
    );
  }
}
